<template>

  <div class="popup" id="wholesale">

    <div class="popup__block">
      <div class="popup__close"></div>
      <div class="popup__title title title_h2">Заказать оптом</div>
      <div class="popup__subtitle">для кофейни/ресторана/кафе</div>
      <div class="popup__content">
        <form @click="importRecaptcha" id="orderForm" class="form" v-on:submit.prevent="onSubmit" action="#">
          <div class="form__inputs form__inputs--2">
            <div class="default-input">
              <input @blur="testInput('name')" v-model="formData.name" :class="['default-input__input', errorName !== '' ? 'error' : '']" type="text" name="name" placeholder="Иван">
              <label class="default-input__label">Имя</label>
              <div class="default-input__error">{{errorName}}</div>
            </div>
            <div class="default-input">
              <input @blur="testInput('phone')" v-model="formData.phone" :class="['default-input__input', errorPhone !== '' ? 'error' : '']" type="tel" name="phone" placeholder="8 987 654 32 10">
              <label class="default-input__label">Телефон</label>
              <div class="default-input__error">{{errorPhone}}</div>
            </div>
            <div class="default-input">
              <input @blur="testInput('email')" v-model="formData.email" :class="['default-input__input', errorEmail !== '' ? 'error' : '']" name="email" type="email" placeholder="ivanov@mail.ru" inputmode="email">
              <label class="default-input__label">E-mail</label>
              <div class="default-input__error">{{errorEmail}}</div>
            </div>
            <div class="default-input">
              <input @blur="testInput('firm')" v-model="formData.firm" :class="['default-input__input', errorFirm !== '' ? 'error' : '']" name="firm" type="text" placeholder="Введите наименование">
              <label class="default-input__label">Наименование организации</label>
              <div class="default-input__error">{{errorFirm}}</div>
            </div>
            <div @click="formData.city=''" class="default-select">
              <select @change="testInput('country')" v-model="formData.country" name="country" :class="['default-select__select', errorCountry !== '' ? 'error' : '']">
                <option data-placeholder="true">Выберите вашу страну</option>
                <option v-for="(country, index) in citydata" :key="index" :value="country.country">{{ country.country }}</option>
              </select>
              <label class="default-input__label">Страна</label>
              <div  class="default-input__error">{{errorCountry}}</div>
            </div>
            <div class="default-input default-input--icon b-list">

                <input v-if="formData.country === '' || formData.country === 'Выберите вашу страну'" disabled :class="['default-input__input b-list__input', errorCity !== '' ? 'error' : '']"  type="text" name="city" placeholder="Начните вводить ваш город">
                <input @click="addScyleStyle()" @blur="testInput('city')" v-model="formData.city" v-else :class="['default-input__input b-list__input', errorCity !== '' ? 'error' : '']" type="text" name="city" placeholder="Начните вводить ваш город">
                <label  class="default-input__label">Город</label>
                <div  class="default-input__error">{{errorCity}}</div>
                <div class="b-list__content scaleCustomFormO">
                <div v-if="checkCity !== null" class="b-list__list">

                <div @click="formData.city = city, deleteScyleStyle(), testInput('city')" v-for="(city, index) in checkCity" :key="index" class="b-list__elem">{{ city }} </div>
                  </div>
                </div>


            </div>
            <div class="form__inputs-input--2">
              <div class="default-input">
                <textarea @blur="testInput('comments')" v-model="formData.comments" :class="['default-input__input default-input__input--textarea', errorComments !== '' ? 'error' : '']"  type="text" name="comments" placeholder="Ваши пожелания, вопросы и любая дополнительная информация"></textarea>
                <label class="default-input__label">Комментарий</label>
                <div  class="default-input__error">{{errorComments}}</div>
              </div>
            </div>
            <div class="form__inputs-input--2">
              <div class="default-checkbox">
                <input @click="testInput('checkPersonalData')" v-model="formData.checkPersonalData" :class="['default-checkbox__input', errorPersonalData !== '' ? 'error' : '']" name="checkPersonData" type="checkbox" id="checkbox-3" required>
                <label class="default-checkbox__label" for="checkbox-3"><span>Согласен(на) на обработку&nbsp;<a :href="agreement" target="_blank"> персональных данных</a></span></label>
                <div class="default-input__error">{{errorPersonalData}}</div>
              </div>
            </div>

            <div class="form__inputs-input--2">
              <div class="form__agree">Нажимая кнопку "отправить" Вы подтверждаете ознакомление с <a :href="politics" target="_blank">  Политикой в отношении обработки персональных данных</a> и даете <a :href="agreement" target="_blank"> Согласие на обработку персональных данных</a></div>
            </div>
            <input hidden class="recaptcha" name="recaptcha" type="text">

          </div>
          <div class="form__submit">
            <div class="form__hint">
              <div class="hint">
                <div class="hint__text">Условия оптового заказа</div>
                <div class="hint__svg">
                  <svg aria-hidden="true">
                    <use xlink:href="./icons/icons.svg#svg-hint"></use>
                  </svg>
                </div>
                <div class="hint__hint">
                  Мы осуществляем дистрибуцию по всей России через региональных представителей по единому оптовому прайсу. При заполнении полей формы «Заказать оптом» Вам будут предложены дистрибьюторы по вашему региону.<br>Если вы крупная компания и вам требуется больше 5 тонн продукта в месяц, то укажите это в разделе «Комментарий» и мы предложим вам вариант выгодные условия прямой поставки.</div>
              </div>
            </div>
            <button @click="sendForm" class="btn form__btn" type="submit">Отправить заявку</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name : "FormOrder",

  props: {
    citydata: {
      type: Array,
      required: true
    },
    politics: {
      type: String,
      required : true
    },
    agreement: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      formData: {
        name : "",
        phone: "",
        email: "",
        comments: "",
        recaptcha: "",
        country: "",
        city: "",
        firm: "",

        checkPersonalData: false
      },

      errorName: "",
      errorPhone: "",
      errorEmail: "",
      errorCountry: "",
      errorCity: "",
      errorComments: "",
      errorFirm: "",
      errorPersonalData: "",
      validName: false,
      validPhone: false,
      validEmail: false,
      validCity: false,
      validComments: true,
      validFirm: false

      // cityData:
      //   [
      //     {
      //       country: 'Россия',
      //       city: ['Челябинск', 'Москва', 'Нижний Новгород']
      //     },
      //     {
      //       country: 'Белорусь',
      //       city: ['Минск', 'Белорусский город1', 'Белорусский город2']
      //     },
      //
      //
      //   ]

    }
  },

  computed: {
    checkCity(){
      let result = null;
      if(this.formData.country !== ""){
        this.citydata.forEach(
            (element) =>
            {
              if( element.country === this.formData.country )
                {
                  if( this.formData.city !== "" )
                    {
                      //result =  element.city.filter(element = element.toLowerCase().indexOf(this.formData.city.toLowerCase()) !== -1)// eslint-disable-line;
                      let cityData = element.city;

                      result = cityData.filter(el => el.toLowerCase().indexOf(this.formData.city.toLowerCase()) !== -1)// eslint-disable-line
                    }
                  else
                    result = element.city

                }


            } )
       }
      return result
    }
  },

  methods: {
    testInput(input)
      {
        if(input === 'name') {
          const regExpName    =/^[а-яёa-z0-9-\.\s]{2,16}$/ui;// eslint-disable-line
          if(!regExpName.test(this.formData.name)) {
            this.errorName='Пожалуйста, введите Ваше имя корректно';
            this.validName = false;
          }
          else {
            this.validName = true;
            this.errorName='';
          }
        }
        if(input === 'phone') {
          //const regExpPhone   =/(\+7|8|7{1})\s\((\d{3})\)\s(\d{3})\-(\d{2})\-(\d{2})/;// eslint-disable-line
          //const regExpPhone   =/^(\+?\d+\-?|\+?\d+\s?|\(?\s?\d+\s?\)?\s?){7,30}$/;// eslint-disable-line
          const regExpPhone   =/^(\s*)?(\+)?([- _()+]?\d[- _()+]?){7,30}(\s*)?$/;// eslint-disable-line

          if(!regExpPhone.test(this.formData.phone)) {
            this.errorPhone='Пожалуйста, введите Ваш телефон корректно';
            this.validPhone = false;
          }
          else {
            this.validPhone = true;
            this.errorPhone='';
          }
        }
        if(input === 'email') {
          const regExpEmail   =/^[\w\.\-]{2,}\@\w+\.[a-z]{2,}$/i;// eslint-disable-line
          if(!regExpEmail.test(this.formData.email)) {
            this.errorEmail='Пожалуйста, введите Вашу эл. почту корректно';
            this.validEmail = false;
          }
          else {
            this.validEmail = true;
            this.errorEmail='';
          }
        }
        if(input === 'city') {
          const regExpCity   =/^[а-яёa-z-\s]{2,30}$/ui;// eslint-disable-line
          if(!regExpCity.test(this.formData.city)) {
            this.errorCity='Пожалуйста, введите Ваш город корректно';
            this.validCity = false;
            setTimeout(()=> {
              document.querySelector('.scaleCustomFormO').removeAttribute("style");
            },200);
          }
          else {
            this.validCity = true;
            this.errorCity='';
          }
        }
        if(input === 'firm') {
          const regExpFirm    =/^[а-яёa-z0-9-\."',\(\)\s]{5,50}$/ui;// eslint-disable-line
          if(!regExpFirm.test(this.formData.firm)) {
            this.errorFirm='Пожалуйста, введите название Вашей организации корректно';
            this.validFirm = false;
          }
          else {
            this.validFirm = true;
            this.errorFirm='';
          }
        }
        if(input === 'comments') {
          const regExpComments   =/^.{0,500}$/ui;// eslint-disable-line
          if(!regExpComments.test(this.formData.comments)) {
            this.errorComments='Пожалуйста, уменьшите количество символов до 500';
            this.validComments = false;
          }
          else {
            this.validComments = true;
            this.errorComments='';
          }
        }
        if(input === 'checkPersonalData') {

          if(this.formData.checkPersonalData) {
            this.errorPersonalData='Согласны с условиями персональных данных?';

          }
          else {

            this.errorPersonalData='';
          }
        }
        if(input === 'country') {

          if(this.formData.country === '' || this.formData.country === 'Выберите вашу страну') {
            this.errorCountry='Пожалуйства, выберите Вашу страну';

          }
          else {

            this.errorCountry='';
          }
        }


      },
    searchCity() {
      this.checkCity = this.checkCity.filter(element = element.toLowerCase().indexOf(this.formData.city.toLowerCase()) !== -1)// eslint-disable-line
    },
    sendForm() {
      if(this.validName && this.validEmail && this.validPhone && this.validCity && this.validComments && this.validFirm && this.formData.checkPersonalData)
        {
          console.log('Все норм');

          //console.log(this.formData);
          const form = document.querySelector('#orderForm');
          const formData=new FormData(form);
          formData.set('form_order', 'y');

          fetch("/local/api/requestHandler.php",{
            method : "POST",
            //headers: {
              //'Content-Type': 'application/json'
            //},
            //body   : JSON.stringify(this.formData)
            body: formData
          })
              .then(response => response.json())
              .then(result =>
              {
                if( result.addSuccess === true )
                  {
                    console.log('Все ок');
                    this.formData.name = "";
                    this.formData.phone = "";
                    this.formData.email = "";
                    this.formData.comments = "";
                    this.formData.firm = "";
                    this.formData.country = "";
                    this.formData.city = "";
                    this.formData.checkPersonalData = false;
                    let event = new Event("click");
                    let success = document.querySelector('#sc');
                    success.dispatchEvent(event);// eslint-disable-line

                  }
                else
                  {
                    console.log('Ошибка');
                  }

              });
        }
      else {
        if(this.formData.name === '') {
          this.errorName='Пожалуйста, введите Ваше имя';
        }
        if(this.formData.phone === '') {
          this.errorPhone='Пожалуйста, введите Ваш телефон';
        }
        if(this.formData.email === '') {
          this.errorEmail='Пожалуйста, введите Вашу эл. почту';
        }
        if(this.formData.city === '') {
          this.errorCity='Пожалуйста, выберите Вашу страну и введите город';
        }
        if(this.formData.country === '' || this.formData.country ===  'Выберите вашу страну') {
          this.errorCountry='Пожалуйста, выберите Вашу страну';
        }
        if(this.formData.firm === '') {
          this.errorFirm='Пожалуйста, введите Вашу Организацию';
        }
        if(!this.formData.checkPersonalData)
          {
            this.errorPersonalData='Согласны с условиями персональных данных?'
          }
      }

    },
    addScyleStyle()
      {
        document.querySelector('.scaleCustomFormO').style.transform = 'scaleY(1)'
      },
    deleteScyleStyle()
      {
        document.querySelector('.scaleCustomFormO').style.transform = 'scaleY(0)'
      },
    test(){

      console.log('123');
    },
    importRecaptcha(){
     const form = document.querySelector('#orderForm');
     const recaptchaInput =  form.querySelector('.recaptcha');


      grecaptcha.ready(function()// eslint-disable-line
      {
        grecaptcha.execute("6Lclq6IkAAAAAIXHfuhf9j0BH1-02I___iqDfRa8", {action : "submit"}).then(function( token )// eslint-disable-line
        {
          recaptchaInput.value=token;

          //console.log(recaptchaInput.value);
        });
      });
      // this.formData.recaptcha = '123';
      // console.log(this.formData.recaptcha);

    }
  },

};
</script>

<style scoped>

</style>